import { createRouter, createWebHistory } from 'vue-router';
import Menu from '../views/Menu.vue';
import Login from '../views/LoginPage.vue';
import Dashboard from '../views/DashboardPage.vue';
import MyRides from '../views/MyRidesPage.vue';
import RideDetails from '../views/RideDetailsPage.vue';
import Settings from '../views/SettingsPage.vue';
import Chat from '../views/ChatView.vue';
import VerifyOtpPage from '../views/VerifyOtpPage.vue';

const routes = [
  {
    path: '/',
    component: Menu,
    children: [
      {
        path: 'dashboard',
        name: 'DashboardPage',
        component: Dashboard,
      },
      {
        path: 'my-rides',
        name: 'MyRidesPage',
        component: MyRides,
      },
      {
        path: 'ride/:id',
        name: 'RideDetails',
        component: RideDetails,
      },
      {
        path: 'settings',
        name: 'Settings',
        component: Settings,
      },
      {
        path: 'chat',
        name: 'Chat',
        component: Chat,
      },
      // other logged-in routes
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component:  Login
  },
  {
    path: '/verify-otp',
    name: 'VerifyOtpPage',
    component:  VerifyOtpPage
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const publicPages = ['/login', '/verify-otp', '/about', '/contact'];

router.beforeEach((to) => {
  const token = localStorage.getItem('token');

  if (publicPages.includes(to.path)) {
    return true; // allow public pages
  }

  if (!token) {
    return { path: '/login' }; // redirect to login
  }

  return true; // allow navigation
});


export default router;
